// extracted by mini-css-extract-plugin
module.exports = {"container":"TestimonialLargeGroup_container__RfIpS","nameAndTitle":"TestimonialLargeGroup_nameAndTitle__suTyy"};